import angular from 'angular';

import PrivilegeListComponent from './privilege-list-component';

export default angular.module('privilege-list', []).component('privilegeList', new PrivilegeListComponent());



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-list/privilege-list-module.js